import React from 'react';
import { Link } from 'react-router-dom';
import { X, Trash2, Plus, Minus, ShoppingBag, Send } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartDrawer = ({ open, onClose }) => {
  const { items, updateQty, removeItem, total } = useCart();

  return (
    <div className={`fixed inset-0 z-[90] ${open ? '' : 'pointer-events-none'}`}>
      <div className={`absolute inset-0 bg-black/70 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`} onClick={onClose} />
      <aside className={`absolute right-0 top-0 h-full w-full max-w-md cb-panel border-l border-white/10 flex flex-col transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between px-5 h-[74px] border-b border-white/10">
          <div className="flex items-center gap-2 font-anton text-xl uppercase">
            <ShoppingBag size={20} className="text-[#a6e22e]" /> Twój koszyk
          </div>
          <button onClick={onClose} className="h-9 w-9 grid place-items-center rounded-full hover:bg-white/10 transition"><X size={20} /></button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3">
          {items.length === 0 && (
            <div className="text-center text-white/50 mt-20">
              <ShoppingBag size={44} className="mx-auto mb-3 opacity-40" />
              <p>Koszyk jest pusty.</p>
              <Link to="/produkty" onClick={onClose} className="btn-green inline-block mt-4 px-5 py-2 text-sm">Zobacz produkty</Link>
            </div>
          )}
          {items.map((i) => (
            <div key={i.id} className="flex gap-3 bg-white/5 rounded-xl p-3">
              <img src={i.image} alt={i.name} className="h-16 w-16 object-contain rounded-lg bg-black/40" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold truncate">{i.name}</p>
                <p className="text-[#a6e22e] text-sm font-bold">{i.price.toFixed(2)} zł</p>
                <div className="flex items-center gap-2 mt-1">
                  <button onClick={() => updateQty(i.id, i.qty - 1)} className="h-6 w-6 grid place-items-center rounded-full bg-white/10 hover:bg-white/20"><Minus size={12} /></button>
                  <span className="text-sm w-6 text-center">{i.qty}</span>
                  <button onClick={() => updateQty(i.id, i.qty + 1)} className="h-6 w-6 grid place-items-center rounded-full bg-white/10 hover:bg-white/20"><Plus size={12} /></button>
                </div>
              </div>
              <button onClick={() => removeItem(i.id)} className="text-white/40 hover:text-[#ff2e2e] transition self-start"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-white/10 px-5 py-4 space-y-3">
            <div className="flex justify-between text-lg">
              <span className="text-white/70">Razem:</span>
              <span className="font-bold text-[#a6e22e]">{total.toFixed(2)} zł</span>
            </div>
            <Link to="/zamowienie" onClick={onClose} className="btn-green w-full py-3 flex items-center justify-center gap-2">
              <Send size={17} /> Przejdź do zamówienia
            </Link>
            <p className="text-white/40 text-xs text-center">Zamówienie finalizujesz na Telegramie.</p>
          </div>
        )}
      </aside>
    </div>
  );
};

export default CartDrawer;
